export { default as RoutesMatches } from './RoutesMatches';
export * from './routes';



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/routes/index.ts